import React from "react";
import PropTypes from 'prop-types';

import style from "./Footer.css";
import Static from "src/lib/Static";


const AppLink = ({ link, image }) => {
  const base = "http://go.onelink.me/32083905?pid=wahanda&c=footer-link&af_web_dp=";
  const url = `${base}${link}`;

  return (
    <a href={url}>
      <img src={image} />
    </a>
  );
};

AppLink.propTypes = {
  link: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired
};

const Footer = ({}) => {
  const content = Static.footer;

  return (
    <footer className={style.footer}>
      <div className={style.container}>
        <div className={style.row}>
          <div className={style.column}>
            <h4 className={style.title}>Book on the go with our app</h4>
            <AppLink
              link={"https%3A%2F%2Fitunes.apple.com%2Fgb%2Fapp%2Ftreatwell%2Fid814443140%2F&#10;"}
              image={"https://cdn1.treatwell.net/images/view/v2.i600714.w140.h45.xC6BF8DE7.png"}
            />
            <AppLink
              link={"https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.wahanda.marketplace%26hl%3Dgb"}
              image={"https://cdn1.treatwell.net/images/view/v2.i600715.w140.h45.xC3F06D9A.png"}
            />
          </div>
          {content.columns.map((column, idx) =>
            <div key={idx} className={style.column}>
              <h4 className={style.title}>{column.title}</h4>
              {column.links.map((link, linkIdx) => (
                <a
                  key={linkIdx}
                  className={style.link}
                  href={link.href}
                >
                  {link.label}
                </a>
              ))}
            </div>
          )}
        </div>
      </div>
    </footer>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./component/App/Footer.js